import { useEffect, useState } from "react"

import { Avatar, Flex, Spin, Statistic, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../Components/Button"
import Private from "../../../Components/Private"
import Icon from "../../../Icon"
import Images from "../../../Images"
import utils from "../../../Utils/utils"

const { Title, Text } = Typography

export default function CheckEmail({ data, onResend, email = "", extraText = "" }) {
  const { Countdown } = Statistic
  const [resendFetching, setResendFetching] = useState(false)
  const [deadline, setDeadline] = useState(null)
  const [firstLoading, setFirstLoading] = useState(true)

  const { t } = useTranslation()

  function handleResend() {
    onResend()
    handleResetTime()
  }
  useEffect(() => {
    handleResetTime()
    setFirstLoading(false)
  }, [])

  function handleResetTime() {
    if (!firstLoading) setDeadline(Date.now() + 1000 * 60)
    setResendFetching(true)
  }
  function onFinish() {
    setResendFetching(false)
    setDeadline(null)
  }

  const resendBlock = (
    <div
      className="sign-up-link check-mail"
      style={{ height: 40, justifyContent: "center", marginTop: 0 }}
    >
      {resendFetching && deadline ? (
        <div className="resend-timer">
          <Countdown
            title=""
            value={deadline}
            onFinish={onFinish}
            format="mm:ss"
            prefix={<span>{t("You will be able to resend link in")} </span>}
          />
          <Spin />
        </div>
      ) : (
        <span>
          {t("Didn’t receive an email?")}{" "}
          <span className="text-link" onClick={handleResend}>
            {t("Resend now")}
          </span>
        </span>
      )}
    </div>
  )
  return (
    <Flex vertical={true} justify={"center"} align={"center"} style={{ paddingTop: 32 }}>
      <Avatar
        size={48}
        style={{
          backgroundColor: "#225AEA",
          borderRadius: "12px",
          border: "none",
          marginBottom: 24
        }}
        icon={<Icon type={"email_notification"} />}
      />

      <Title level={4} style={{ marginBottom: 8 }}>
        {t("You’ve got mail")}
      </Title>

      <Text type="secondary" style={{ textAlign: "center" }}>
        {`${t("Check the email letter sent to")} `}
        <Text>
          <Private>{data?.email ? data?.email : email}</Private>
        </Text>
        .{extraText}
      </Text>

      <ButtonComponent
        size="large"
        href={`https://mail.${utils.checkMailDomain(data?.email || email).link}.com`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex center"
        block
        style={{ margin: "40px 0 12px" }}
      >
        <img
          height={20}
          className="btn-icon icon-space"
          src={Images[utils.checkMailDomain(data?.email || email).type]}
          alt=""
        />
        {t("Go To")} {utils.checkMailDomain(data?.email || email).name}
      </ButtonComponent>

      {resendBlock}
    </Flex>
  )
}
